import type { AnyID, SceneObjects, Store } from '@types'
import { collectLinkedDescendantIds } from './collectLinkedDescendantIds'
import { isAccesorioFregaderoCatalog } from './isAccesorioFregaderoCatalog'
import { isCorteKitCatalog } from './isCorteKitCatalog'
import { purgeSceneGlbForCatalog } from './purgeSceneGlbForCatalog'

export function collectIdsToDeleteWithLinkedParent(
  items: Map<string, SceneObjects>,
  parentId: string,
): Set<AnyID> {
  const ids = collectLinkedDescendantIds(items, parentId)

  items.forEach((item, id) => {
    if (
      !isCorteKitCatalog(item.catalogID as string) &&
      !isAccesorioFregaderoCatalog(item.catalogID as string) &&
      !isAccesorioFregaderoCatalog((item as { codigo?: string }).codigo)
    )
      return
    const fp = (item as { firstParentID?: string }).firstParentID
    if (fp != null && String(fp) === String(parentId)) {
      ids.add(id as AnyID)
    }
  })

  return ids
}

/** Borra hijos enlazados y CORTEKIT asociados al padre (no borra el padre). */
export function removeLinkedHierarchyFromStore(store: Store, parentId: string): void {
  const ids = collectIdsToDeleteWithLinkedParent(store.items, parentId)

  ids.forEach((id) => {
    const child = store.items.get(id)
    if (!child) return
    const catalogID = child.catalogID
    const codigo = (child as { codigo?: string }).codigo
    store.price -= child.price || 0
    store.items.delete(id)
    store.sceneBoundingBoxes.delete(id)
    store.collisionableItems.delete(id)
    Object.values(store.layers).forEach((layer) => {
      layer.items.delete(id)
      layer.selected.delete(id)
    })
    purgeSceneGlbForCatalog(store, catalogID, codigo)
  })

  const parent = store.items.get(parentId) as { childs?: Set<AnyID> } | undefined
  parent?.childs?.clear()
}
